import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { Insert } from "./helper";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { EnumEstadoCivil } from "src/services/types/EnumEstadoCivil";
import { PropertyRegime } from "src/services/interfaces/UserInterface";
import { EstadoCivilEnum } from 'src/services/interfaces/trade/tradeOwner/EstadoCivilEnum';
import { PropertyRegimeEnum } from 'src/services/interfaces/trade/tradeOwner/PropertyRegimeEnum';
import * as moment from "moment";
import { GetPersonType, PersonTypeEnum } from "src/util/GetPersonType";

export function ValidateCommissionFormat(commission: number, isCommissionAbsolute: boolean, price?: number) {
  let newCommission = commission;
  if (isCommissionAbsolute) {
    if (price) {
      newCommission = commission / price;
    } else {
      ShowNotification.Error("Erro ao calcular comissão", "Preço não pode ser zero.");
    }
  } else {
    if (newCommission > 1) {
      newCommission = ConvertCommissionToPercentage(newCommission);
    }
  }
   
  return newCommission;
}

export function ConvertCommissionToPercentage(value: number) {
  const length: number = 4;
  let valueString: string = String(value).replace(".", "");
  if (valueString.length < length) {
    for (let zeroes = 0; zeroes < length - valueString.length; zeroes++) {
      valueString = `${valueString}0`;
    }
  }
  valueString = Insert(valueString, 2, ".");
  const numericValue = Number(valueString);
  return numericValue / 100;
}

export function userHaveSpouse(trade: ITrade): boolean {
  if (trade.tradeOwner) {
    const isMarried = trade.tradeOwner.civilStatus === EnumEstadoCivil.casado || trade.tradeOwner.civilStatus === EnumEstadoCivil.uniao_estavel;
    const hasPropertyRegime =
      (trade.tradeOwner && trade.tradeOwner.propertyRegime === PropertyRegime.ComunhaoParcial) || trade.tradeOwner.propertyRegime === PropertyRegime.ComunhaoTotal;
    return isMarried && hasPropertyRegime;
  } else {
    return false;
  }
}


export function needMarriageCertificate(trade: ITrade){
  return trade?.tradeOwner?.civilStatus && trade?.tradeOwner?.civilStatus !== EstadoCivilEnum.solteiro;
}

export function needMarriageDate(trade: ITrade){
  return needMarriageCertificate(trade) && trade?.tradeOwner?.propertyRegime === PropertyRegimeEnum.ComunhaoTotal;
}

export function needMariagePrenuptialAgreement(trade: ITrade){
  return needMarriageDate(trade) && trade?.tradeOwner?.marriageDate && moment(trade?.tradeOwner?.marriageDate).year() > 1977;
}

export function ValidateAllUserFieldsAreFilled(trade: ITrade) {
  let isValid = false;
  let message = "";

  const shouldNotBeNullUserFielsPJ = [
    "address",
    "cpfCnpj",
    "fullName",
    "login",
    "phoneNumber"
  ];

  const shouldNotBeNullUserFielsPF = [
    "address",
    "birthDate",
    "civilStatus",
    "cpfCnpj",
    "fullName",
    "login",
    "mothersName",
    "nationality",
    "phoneNumber",
    "profession",
    "propertyRegime",
    "rg"
  ];

  if (trade.tradeOwner) {
    isValid = true;
    const personType = GetPersonType(trade?.tradeOwner?.cpfCnpj);
    
    (personType === PersonTypeEnum.PF ? shouldNotBeNullUserFielsPF : shouldNotBeNullUserFielsPJ).forEach(prop => {
      if (!trade.tradeOwner[prop]) {
        isValid = false;
        message = "Dados Cadastrais Incompletos campo: " + prop;
      }
    });
  }
  return { isValid, message };
}

export function ValidateAllSpouseFieldsAreFilled(trade: ITrade) {
  let isValid = true;
  let message = "";

  if (userHaveSpouse(trade)) {
    const shouldNotBeNullSpouseFiels = ["fullName", "cpf", "rg", "rgState", "profession", "nationality", "email", "birthDate"];
    if (trade.tradeOwner.spouse) {
      shouldNotBeNullSpouseFiels.forEach(prop => {
        if (!trade.tradeOwner.spouse[prop]) {
          isValid = false;
          message = "Dados Cadastrais do Cônjuge estão incompletos campo: " + prop;
        }
      });
    }
  }
  return { isValid, message };
}




// WEBPACK FOOTER //
// ./src/util/Validations.ts